'use strict';

angular.module('controllers')
	.directive('dragDropRes', ['$compile', '$parse', '$timeout', '$rootScope', function($compile, $parse, $timeout, $rootScope) {
		var timer = null;
		return {
			restrict: 'A',
			link: function (scope, element, attr, ctrl) {

                        angular.element(element[0]).css('cursor', 'move');
                        
				element.bind('dragstart', function (event) { 
                                       //console.log(event.type)
					var el = element[0];
					el.draggable = true;

					/*var elInput = angular.element(document.querySelectorAll('input'));
					console.log(elInput);
					angular.forEach(elInput, function (item, key) {
						elInput[key].addEventListener(
							'focus',
							function (event) {
								console.log('foc');
								elInput.closest('md-card').attr("draggable", false);
								return false;
							},
							false
						);
						elInput[key].addEventListener(
							'blur',
							function (event) {
								console.log('blur');
								elInput.closest('md-card').attr("draggable", true);
								return false;
							},
							false
						);
					});*/

					event.originalEvent.dataTransfer.effectAllowed = 'move';
					var style = window.getComputedStyle(event.target, null);
                                        
                                           var format = "text/plain";
                                           var ua = window.navigator.userAgent;
                                           var msie = ua.indexOf("MSIE ");
                                           if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                                                   var format = "text";
                                           } 
					event.originalEvent.dataTransfer.setData(format, (parseInt(style.getPropertyValue("left"), 10) - event.originalEvent.clientX) + ',' + (parseInt(style.getPropertyValue("top"), 10) - event.originalEvent.clientY)+','+el.id); 

					var body = angular.element(document).find('body')[0];
					body.addEventListener('dragover', function (event) { 
                                                        //console.log(event.type)
							event.preventDefault();
							return false;
						},
						false
					);

					body.addEventListener('drop', function (event) { 
                                                       //console.log(event.type)
							var offset = event.dataTransfer.getData(format).split(',');
                                                           
							var dropElement = document.getElementById(offset[2]);
							var xpos = event.clientX + parseInt(offset[0], 10);
							var ypos = event.clientY + parseInt(offset[1], 10);

							if(dropElement !== null) {
								dropElement.style.left = (xpos) + 'px';
								dropElement.style.top = (ypos) + 'px';
							}
							//console.log(dropElement.style.left +'------'+dropElement.style.top)
							
							if (angular.isUndefined($rootScope.dropResult)) {
								$rootScope.dropResult = {};
							}
							$rootScope.dropResult[ offset[2]] = {'x':dropElement.style.left, 'y': dropElement.style.top}
													
							event.preventDefault();
							return false;
						},
						false
					);
				});
                               
                               var anchor = {
                                  top: 0,
                                  left: 0
                                };
                               var dates = '';        
                               element.bind('touchstart', function (event) { 
                                       //console.log(event.type)
                                        var el = element[0];
                                        el.draggable = true;
                                                                     
                                        var ev = event.originalEvent.changedTouches;
                                        dates =  ev[0].clientX + ',' + ev[0].clientY+','+el.id; 
                                        
                                          var elementRect = el.getBoundingClientRect();
                                           anchor = {
                                            top: ev[0].clientY - elementRect.top,
                                            left: ev[0].clientX - elementRect.left
                                          };
   
                              });      
                                                                                                            
                               var body = angular.element(document).find('body')[0];
                               element[0].addEventListener('touchmove', function (event) { 
                                        //console.log(event.type)
                                        event.preventDefault();
                                        var offset = dates.split(',');
                                        var dropElement = document.getElementById(offset[2]);

                                        /*var xpos = event.changedTouches[0]['clientX'] ;
                                        var ypos = event.changedTouches[0]['clientY'] ;*/
                                        
                                       // console.log(anchor)
                                        //console.log(event)
                                        //var xpos = event.changedTouches[0]['clientX'] - anchor.left;
                                        //var ypos = event.changedTouches[0]['clientY'] - anchor.top;
                                        
                                        //console.log(dropElement.offsetHeight)
                                        //console.log(dropElement.offsetWidth)
                                        //var xpos = event.changedTouches[0]['clientX'] - dropElement.offsetWidth/2;
                                        //var ypos = event.changedTouches[0]['clientY'] - dropElement.offsetHeight/2;
                                        var xpos = event.changedTouches[0]['clientX'] - 200;
                                        var ypos = event.changedTouches[0]['clientY'] - 200;
                                        //console.log(xpos);
                                        //console.log(ypos);

                                        if(dropElement !== null) {
                                                dropElement.style.left = xpos + 'px';
                                                dropElement.style.top = ypos + 'px';
                                        }
                                        if (angular.isUndefined($rootScope.dropResult)) {
                                                $rootScope.dropResult = {};
                                        }
                                        $rootScope.dropResult[offset[2]] = {};
                                        $rootScope.dropResult[offset[2]] = {'x':dropElement.style.left, 'y': dropElement.style.top}
                                        
                                         return false;
                                        },
                                        false
                                );

 //});

			}
		}
	}]);

